import { Search, X } from "lucide-react";
import { Input } from "@/components/atoms/Input";

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
}

export function SearchInput({ value, onChange, placeholder = "Search...", autoFocus }: Props) {
  return (
    <Input
      leading={<Search size={16} />}
      trailing={
        value ? (
          <button onClick={() => onChange("")} aria-label="Clear search" className="text-bridge-muted hover:text-bridge-fg">
            <X size={14} />
          </button>
        ) : null
      }
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  );
}